import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import orgSlice from "./orgSlice";
import messageSlice from "./messageSlice";

const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    org : orgSlice.reducer,
    message : messageSlice.reducer,
  },
});

export default store;